declare global {
    interface Window {
        Alpine: any;
    }
}

// import css
import '~/css/rbfa.css'

// import icons
import '~/js/assets/icons.js'

// alpine
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse';
window.Alpine = Alpine
Alpine.plugin(focus)
Alpine.plugin(collapse);
Alpine.start()

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR active')
    })
}